import { useState } from 'react'
import { Navigate, useLocation } from 'react-router-dom'
import { AlertTriangle, Loader2, ShieldCheck } from 'lucide-react'
import { Alert, AlertDescription, AlertTitle } from '@/components/ui/alert'
import { Button } from '@/components/ui/button'
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card'
import { useAuth } from '@/features/auth/useAuth'

/** Google is the only way in, exactly like the Android app. */
export function LoginPage() {
  const { user, isAdmin, isLoading, error, signInWithGoogle } = useAuth()
  const location = useLocation()
  const [isSigningIn, setSigningIn] = useState(false)

  if (user && isAdmin) {
    const from = (location.state as { from?: string } | null)?.from
    return <Navigate to={from ?? '/'} replace />
  }

  const handleSignIn = async () => {
    setSigningIn(true)
    try {
      await signInWithGoogle()
    } catch {
      // The provider already put a readable message into `error`.
    } finally {
      setSigningIn(false)
    }
  }

  return (
    <main className="from-background to-muted flex min-h-svh items-center justify-center bg-gradient-to-br p-6">
      <Card className="w-full max-w-md">
        <CardHeader className="items-center gap-3 text-center">
          <div className="bg-primary/10 text-primary mx-auto flex size-14 items-center justify-center rounded-2xl">
            <ShieldCheck className="size-7" />
          </div>
          <CardTitle className="text-xl">Estimate Pro — админ-панель</CardTitle>
          <CardDescription>
            Вход только для администраторов. Роль берётся из профиля в Firestore.
          </CardDescription>
        </CardHeader>
        <CardContent className="flex flex-col gap-4">
          {error ? (
            <Alert variant="destructive">
              <AlertTriangle />
              <AlertTitle>Ошибка входа</AlertTitle>
              <AlertDescription>{error}</AlertDescription>
            </Alert>
          ) : null}

          <Button
            size="lg"
            className="w-full"
            onClick={handleSignIn}
            disabled={isSigningIn || isLoading}
          >
            {isSigningIn || isLoading ? (
              <Loader2 className="animate-spin" />
            ) : (
              <GoogleGlyph />
            )}
            Войти через Google
          </Button>

          <p className="text-muted-foreground text-center text-xs">
            Доступ проверяется на сервере правилами Firestore Security Rules, а не этой страницей.
          </p>
        </CardContent>
      </Card>
    </main>
  )
}

/** Inline Google mark: no extra dependency, no external request. */
function GoogleGlyph() {
  return (
    <svg viewBox="0 0 24 24" className="size-4" aria-hidden="true">
      <path
        fill="#EA4335"
        d="M12 10.2v3.9h5.5c-.2 1.3-1.6 3.8-5.5 3.8-3.3 0-6-2.7-6-6s2.7-6 6-6c1.9 0 3.1.8 3.8 1.5l2.6-2.5C16.7 3.3 14.6 2.4 12 2.4 6.7 2.4 2.4 6.7 2.4 12s4.3 9.6 9.6 9.6c5.5 0 9.2-3.9 9.2-9.4 0-.6-.1-1.1-.2-1.6H12z"
      />
    </svg>
  )
}

export { LoginPage as default }
